import { type RouteObject } from 'react-router'

/**
 * Creates routes for waitlist feature.
 */
export function createRoutes(): RouteObject[] {
  return [
    {
      path: 'waitlist',
      lazy: {
        Component: () =>
          import('@/features/waitlist/WaitlistView/').then((r) => r.default),
      },
    },
  ]
}
